import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { showModal } from '../../actions';
import {
  setSidebarActiveTab,
  setSidebarOpen,
  showConfirmationModal,
} from '../../actions/App';
import { deletePerson } from '../../actions/People';

import { sendTrackingEvent } from '../../helpers';
import {
  userCan,
  userHasCap,
  userIsAdmin,
} from '../../helpers/Auth';
import { addFlashMessage } from '../../helpers/FlashMessages';

const PeopleItem = ({ dispatch, person }) => {
  const intl = useIntl();

  const openFilters = () => {
    dispatch(setSidebarActiveTab('2'));
    dispatch(setSidebarOpen(true));
  };

  const openPersonNameEditModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(showModal('EditPersonNameModal', {
      className: 'modal-edit-person-name',
      person,
    }));
  };

  const openChangePersonModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(showModal('ChangePersonModal', {
      className: 'modal-change-person',
      person,
    }));
  };

  const handleDeletePerson = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
      text: intl.formatMessage({
        defaultMessage: `Are you sure you want to delete this person? It cannot be undone!`,
      }),
      confirmText: intl.formatMessage({ defaultMessage: 'Delete' }),
      onConfirm: () => (
        dispatch(deletePerson(person.uuid)).then(() => {
          addFlashMessage({
            type: 'success',
            text: intl.formatMessage({ defaultMessage: 'Person has been deleted' }),
          });

          sendTrackingEvent('person-deleted');
        })
      ),
    };

    dispatch(showConfirmationModal(modalParams));
  };

  return (
    <div className="person-wrapper">
      <Link to={`/files?people=${person.uuid}`} onClick={openFilters}>
        <div className="person-thumbnail">
          <div className="person-thumbnail-image" style={{ backgroundImage: `url(${person.image_path}` }} />
          <span className="person-faces">
            <i className="far fa-file" />
            {person.visible_faces}
          </span>
        </div>
        <div className="person-name">
          <span>
            {person.name ? (
              person.name
            ) : (
              intl.formatMessage({ defaultMessage: 'Unnamed person' })
            )}
          </span>
          {(userCan('person.edit') || userHasCap('edit_people')) && (
            <UncontrolledDropdown>
              <DropdownToggle nav tag="button" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                <i className="far fa-ellipsis-h" />
              </DropdownToggle>
              <DropdownMenu className="person-dropdown-menu" container="body">
                <DropdownItem
                  onClick={openPersonNameEditModal}
                >
                  <i className="fas fa-pencil" />
                  {intl.formatMessage({ defaultMessage: 'Edit name' })}
                </DropdownItem>
                <DropdownItem
                  onClick={openChangePersonModal}
                >
                  <i className="fas fa-merge" />
                  {intl.formatMessage({ defaultMessage: 'Merge' })}
                </DropdownItem>
                {userIsAdmin() && (
                  <>
                    <DropdownItem divider />
                    <DropdownItem
                      onClick={handleDeletePerson}
                    >
                      <i className="fas fa-trash" />
                      {intl.formatMessage({ defaultMessage: 'Delete' })}
                    </DropdownItem>
                  </>
                )}
              </DropdownMenu>
            </UncontrolledDropdown>
          )}
        </div>
      </Link>
      {!person.name && (
        <i className="fas fa-circle-exclamation person-thumbnail-icon" />
      )}
    </div>
  );
};

PeopleItem.propTypes = {
  dispatch: PropTypes.func.isRequired,
  person: PropTypes.object.isRequired,
};

export default connect()(PeopleItem);
